import { F } from '@mobily/ts-belt'
import type { QueryObserverResult } from '@tanstack/vue-query'
import type { ComputedRef, InjectionKey, Ref } from 'vue'
import { inject } from 'vue'

import type { DietSearchDish, DietSearchIngredient } from '@/types/Diet'
import type { Nutrients } from '@/utils/nutrients'

type Data = {
  dishes: DietSearchDish[]
  ingredients: DietSearchIngredient[]
}

export type DietDetailProvider = {
  nutrientValue: Ref<'choosen' | Nutrients>
  nutrients: ComputedRef<Nutrients[]>
  refetchSearchDishesAndIngredients: () => Promise<QueryObserverResult<Data>>
  searchDishesAndIngredients: Ref<Data | undefined>
  searchDishesAndIngredientsLoading: Ref<boolean>
  searchDishesAndIngredientsStatus: Ref<'error' | 'success' | 'pending'>
  selectedDayIndex: Ref<number>
  showAllDays: Ref<boolean>
}

export const DietDetailInject = Symbol() as InjectionKey<DietDetailProvider>

export const useDietDetailProvider = () => F.coerce<DietDetailProvider>(inject(DietDetailInject))
